import React from "react";
import "./AboutDetail.scss";
import { profile2 } from "assets";
import { FaFacebookF, FaGithub, FaYoutube, FaInfo } from "react-icons/fa";
import { cv2 } from "assets";
import { useTranslation } from "react-i18next";

const Badge = ({ name }) => {
  return <span>{name}</span>;
};
const BadgeList = [
  {
    name: "react",
    bgColor: "#f57550",
  },
  {
    name: "redux",
    bgColor: "#b03785",
  },
  {
    name: "html",
    bgColor: "#eb6e6c",
  },
  {
    name: "scss",
    bgColor: "#541e1b",
  },
  {
    name: "react native",
    bgColor: "#e12e48",
  },
  {
    name: "Node Js",
    bgColor: "#4c0ff6",
  },
  {
    name: "My SQL",
    bgColor: "#011f10",
  },
];

const AboutDetail = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="back-link">
        <a href="/">
          <button type="button" className="btn-custom">
            Back to Home
          </button>
        </a>
      </div>
      <section className="app__about_detail app__flex">
        <h2 className="head-text">About Me</h2>
        <div className="app__about_detail-content">
          <div className="app__about_detail-content_img">
            <img src={profile2} alt="about_img" />
            <div className="app__about_detail-content_img-social">
              <div>
                <a
                  href="https://fb.com/fuzethien"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
              </div>
              <div>
                <a
                  href="https://github.com/thien115116"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaGithub />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/channel/UCiJI14qVaMKfHooP0mVdF8Q"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>
          <div className="app__about_detail-content_info">
            <div className="app__about_detail-content_info-introduce">
              <FaInfo />
              <h3> Tóm tắt về bản thân</h3>
              <div>
                <span>{t("section.about-detail.part1")} </span>
                <span style={{ color: "var(--secondary-color)" }}>
                  Trần Ngọc Thiên
                </span>
                <span> {t("section.about-detail.part2")}</span>
              </div>
              <div>{t("section.about-detail.part3")}</div>
              <div>{t("section.about-detail.part4")}</div>
            </div>

            <div className="app__about_detail-content_info-language">
              <h3>{t("section.about-detail.part5")}:</h3>
              <ul>
                {BadgeList.map((badge, i) => (
                  <li
                    className="badge"
                    key={i}
                    style={{ backgroundColor: `${badge.bgColor}` }}
                  >
                    <Badge name={badge.name} />
                  </li>
                ))}
              </ul>
            </div>

            <div>{t("section.about-detail.part6")}</div>
            <div className="app__about_detail-content_info-hire">
              <a href={cv2} target="_blank" rel="noreferrer">
                <button type="button" className="btn-custom">
                  Tải CV
                </button>
              </a>
              <a href="mailTo:job.tranthien@gmail.com" target="_blank" rel="noreferrer">
                <button type="button" className="btn-custom">
                  Hire Me
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutDetail;
